import { ReservationContextInterface } from "@/contexts/reservation_state";
import { saveReservationContext } from "./reservation-context";

interface RedirectOptions {
  returnPath?: string;
  reservationContext?: ReservationContextInterface;
}

export function portalClienteUrl(path = '') {
  return `${process.env.NEXT_PUBLIC_PORTAL_CLIENTE}${path}`;
}

export function portalClienteNewPassword(email: string, session: string, query: Record<string, string | string[] | undefined>, options: RedirectOptions = {}) {
  const { returnPath = '/pagamento', reservationContext } = options;
  const currentDomain = window.location.hostname;

  if (reservationContext) {
    saveReservationContext(reservationContext);
  }

  const ref = Buffer.from(JSON.stringify({
    domain: currentDomain,
    path: returnPath,
    query,
  })).toString('base64');

  return portalClienteUrl(`/criar-conta/nova-senha?fluxo=reserva&origem=rac&email=${email}&session=${session}&x-ref=${ref}`);
}

export function portalClienteCreateAccount(query: Record<string, string | string[] | undefined>, options: RedirectOptions = {}) {
  const { returnPath = '/criar-reserva', reservationContext } = options;
  const currentDomain = window.location.hostname;

  if (reservationContext) {
    saveReservationContext(reservationContext);
  }

  const ref = {
    protocol: 'https://',
    domain: currentDomain,
    path: returnPath,
    query
  };

  if (currentDomain === 'localhost') {
    ref.protocol = 'http://';
  }

  const refBase64 = Buffer.from(
    JSON.stringify(ref))
    .toString('base64');

  return portalClienteUrl(`/criar-conta?&fluxo=reserva&origem=rac&x-ref=${refBase64}`);
}

export function portalClienteForgotPassword(query: Record<string, string | string[] | undefined>, options: RedirectOptions = {}) {
  const { returnPath = '/criar-reserva', reservationContext } = options;
  const currentDomain = window.location.hostname;

  if (reservationContext) {
    saveReservationContext(reservationContext);
  }

  const ref = {
    protocol: 'https://',
    domain: currentDomain,
    path: returnPath,
    query,
  };

  if (currentDomain === 'localhost') {
    ref.protocol = 'http://';
  }

  const refBase64 = Buffer.from(
    JSON.stringify(ref))
    .toString('base64');

  return portalClienteUrl(`/esqueci-minha-senha?&fluxo=reserva&origem=rac&x-ref=${refBase64}`);
}
